import { ActivityStatus } from "../../../../../../shared/enums/ActivityStatus";
import Icon from "../../../../../../assets/icons";
import React from "react";

export default function ActionIndicatorIcon(props: { activityStatus?: ActivityStatus }) {
  return (
    <div className="dashboard_actions_programTimeline_indicators">
      <span className="dashboard_actions_programTimeline_indicators--status">
        {props.activityStatus === ActivityStatus.COMPLETED && <Icon.Check />}
        {props.activityStatus === ActivityStatus.ACTION_REQUIRED && <Icon.Exclamation />}
        {props.activityStatus === ActivityStatus.ON_GOING && <Icon.OnGoing />}
      </span>
    </div>
  );
}
